import { render, staticRenderFns } from "./AnalyticsData.vue?vue&type=template&id=283b859a&scoped=true"
import script from "./AnalyticsData.vue?vue&type=script&lang=js"
export * from "./AnalyticsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283b859a",
  null
  
)

export default component.exports